var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 45,
    viewBox: "0 0 51 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8901 4.15973C44.2332 1.4759 40.7025 0 36.9465 0C33.1905 0 29.6638 1.4759 27.0069 4.15973L25.4965 5.68763L23.9862 4.16373C21.3333 1.4799 17.8026 0 14.0466 0C10.2905 0 6.75987 1.4799 4.10693 4.16373C-1.36897 9.70737 -1.36897 18.7268 4.10693 24.2744L23.9506 44.3491C24.3618 44.7651 24.9114 44.9971 25.4965 44.9971C25.54 44.9971 25.5796 44.9971 25.6231 44.9971C26.2319 45.0291 26.8527 44.7971 27.2955 44.3491L43.822 27.3822C43.8576 27.3502 43.8892 27.3142 43.9209 27.2782L46.8901 24.2784C52.37 18.7348 52.37 9.71137 46.8901 4.16373V4.15973ZM36.9465 4.42371C39.5322 4.42371 41.9677 5.44365 43.7983 7.29153C47.5702 11.1113 47.5702 17.3309 43.7983 21.1506L40.7381 24.2424C40.7065 24.2744 40.6709 24.3104 40.659 24.3264L25.6112 39.7774L7.19873 21.1466C3.42688 17.3269 3.42688 11.1113 7.19873 7.29153C9.03326 5.43965 11.4648 4.41971 14.0466 4.41971C16.6284 4.41971 19.0638 5.43965 20.8984 7.29153L23.9506 10.3793C24.8046 11.2433 26.1884 11.2433 27.0424 10.3793L30.0987 7.28753C31.9292 5.43965 34.3608 4.41971 36.9465 4.41971V4.42371Z",
    fill: "#726FB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutlined);
export default __webpack_public_path__ + "static/media/heart-outlined.81daabb0ccd541978b49a505145974d7.svg";
export { ForwardRef as ReactComponent };